import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconFontModule } from '../icon-font/icon-font.module';
import { BackButtonComponent } from './back-button.component';

@NgModule({
    imports: [
        CommonModule,
        IconFontModule
    ],
    declarations: [
        BackButtonComponent
    ],
    exports: [
        BackButtonComponent
    ]
})

export class BackButtonModule {
}
